import React from 'react';
import { Helmet } from 'react-helmet-async';
import loadable from '@loadable/component';
import { useSelector } from 'react-redux';
import { FILTER_NAMES, FILTER_TYPES } from '../../shared/enums';
import { selectLocalizationData } from '../features/localization/localizationSlice';
import { price as PRODUCT_PRICES } from '../static-data/productStatic';

const ProductHero = loadable(() => import('../components/product-landing/ProductHero'));
const ProductOrder = loadable(() => import('../components/product-landing/ProductOrder'));
const ProductFeatures = loadable(() => import('../components/product-landing/ProductFeatures'));
const ProductReviews = loadable(() => import('../components/product-landing/ProductReviews'));
const ProductFilter = loadable(() => import('../components/product-landing/ProductFilter'));
const ProductStats = loadable(() => import('../components/product-landing/ProductStats'));
const ProductPerformanceStats = loadable(() => import('../components/product-landing/ProductPerformanceStats'));
const ContentSlider = loadable(() => import('../components/product-landing/ContentSlider'));
const ProductTestimonial = loadable(() => import('../components/product-landing/ProductTestimonial'));
const ProductOrderAlt = loadable(() => import('../components/product-landing/ProductOrderAlt'));
const ProductFaqs = loadable(() => import('../components/product-landing/ProductFaqs'));
/**
  * @param props
 * @return {JSX.Element}
 * @constructor
 */

const ProductLanding = props => {
  const {
    route,
    staticContext,
    match: {
      params: { type },
    },
  } = props;

  const localization = useSelector(selectLocalizationData);

  const page = Object.keys(FILTER_TYPES)
    .find(key => FILTER_TYPES[key] === type);

  if (!page || !PRODUCT_PRICES[page]) {
    if (staticContext) staticContext.notFound = true;
    return null;
  }

  const title = `Mila Air Purifier: ${FILTER_NAMES[page] || FILTER_NAMES.BB}`;

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="title" content={route?.meta?.title || title} />
        <meta name="description" content={route?.meta?.description} />
      </Helmet>
      <ProductHero />
      <ProductOrder type={page} localization={localization} />
      <ProductFeatures type={page} localization={localization} />
      <ProductReviews />
      <ProductFilter />
      <ProductStats type={page} localization={localization} />
      <ProductPerformanceStats type={page} />
      <ContentSlider />
      <ProductTestimonial />
      <ProductOrderAlt type={page} localization={localization} />
      <ProductFaqs type={page} localization={localization} />
    </>
  );
};

ProductLanding.defaultProps = {
  staticContext: {},
};

export default ProductLanding;
